import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const useApplyV2Theme = () => {
  const { sitecoreContext } = useSitecoreContext();

  const siteSettings: any = sitecoreContext?.siteSettings;
  const isToapplyV2Theme: boolean = siteSettings?.applyV2Theme?.value;

  return { isToapplyV2Theme };
};

export default useApplyV2Theme;
